export const optionPie2 = {
  tooltip: {
    trigger: 'item'
  },
  legend: {
    orient: 'vertical',
    left: 'left',
    textStyle: {
      fontSize: 18
    }
  },
  color: ['#2C2A74', '#2c698d', '#bae8e8', '#e3f6f5', '#f2f3f4'],
  series: [
    {
      name: 'TBD',
      type: 'pie',
      radius: '80%',
      data: [
        { value: Math.floor(Math.random() * 101), name: 'TBD' },
        { value: Math.floor(Math.random() * 101), name: 'TBD2' },
        { value: Math.floor(Math.random() * 101), name: 'TBD3' },
        { value: Math.floor(Math.random() * 101), name: 'TBD4' },
        { value: Math.floor(Math.random() * 101), name: 'TBD5' }
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
}
